import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-9 sm:px-14 md:px-32 xl:px-56 py-9 md:py-20 flex-col-grow" }
const _hoisted_2 = { class: "flex-col-grow justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col lg:flex-row-reverse items-center justify-around"
}
const _hoisted_4 = { class: "px-5 sm:py-10 w-full max-w-lg search-form-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchForm = _resolveComponent("SearchForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bg-image brand-img search-vouchers-brand" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_Transition, {
          name: "fade",
          onAfterLeave: _ctx.afterTransition
        }, {
          default: _withCtx(() => [
            (_ctx.show)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mt-6 mb-20 bg-image sm:hidden lg:block lg:m-0 brand-img-alt" }, null, -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pb-5 sm:pb-0 sm:flex" }, [
                      _createElementVNode("div", { class: "sm:flex-grow" }, [
                        _createElementVNode("h1", { class: "font-medium text-3xl sm:text-2xl md:text-4xl text-base-color-alt" }, " Pago Express "),
                        _createElementVNode("p", { class: "my-6 sm:mt-3 sm:mb-4 md:mt-5 md:mb-8 w-full max-w-xs leading-relaxed text-gray-3" }, [
                          _createTextVNode(" Ingresa con tu rut y selecciona lo que "),
                          _createElementVNode("br"),
                          _createTextVNode(" deseas pagar. Simple, fácil, rápido. ")
                        ])
                      ]),
                      _createElementVNode("div", { class: "items-center hidden sm:flex lg:hidden" }, [
                        _createElementVNode("div", { class: "bg-image brand-img-alt" })
                      ])
                    ], -1)),
                    _createVNode(_component_SearchForm, { onPay: _ctx.onPay }, null, 8, ["onPay"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onAfterLeave"])
      ])
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hidden w-full h-16 bg-gray brand-banner" }, null, -1))
  ], 64))
}